<template>
  <div>
    <vue-form
      class="form-horizontal form-validation"
      :state="formstate"
      @submit.prevent="onSubmit"
    >
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link
            :to="{
              name: 'coupon_give_list',
              params: {
                queryTab1: $route.params.queryTab1,
                queryTab2: $route.params.queryTab2,
                collapse: $route.params.collapse,
              },
            }"
            class="btn btn-ptc1"
            tag="button"
            >返回</router-link
          >
        </b-col>
        <b-col class="text-center title">點數兌換券上架 / 商品券贈送 / 編輯</b-col>
        <b-col class="text-right">
          <button
            type="submit"
            class="btn btn-save"
            @click="checkModelByOpen(1)"
            v-if="FunctionPermission > 1"
          >
            儲存
          </button>
          <button
            type="submit"
            class="btn btn-publish"
            :disabled="canDelete"
            @click="checkModelByOpen(2)"
          >
            下架
          </button>
        </b-col>
      </b-row>
      <div id="func-content">
        <div class="contact-page">
          <b-modal ref="checkModel" hide-footer :title="this.checkModelTitle">
            <b-container fluid>
              <form>
                <div class="row mt-3" style="text-align: center">
                  <label class="control-label"
                    >確定要{{ this.checkModelTitle }}?</label
                  >
                </div>
                <div class="float-right">
                  <b-btn variant="primary" @click="edit()">確認</b-btn>
                  <b-btn variant="secondary" @click="checkModelByCancel"
                    >取消</b-btn
                  >
                </div>
              </form>
            </b-container>
          </b-modal>
          <div class="row">
            <div class="col-lg-12">
              <b-card class="bg-warning-card">
                <div class="row">
                  <b-container fluid>
                    <form>
                      <div class="row mb-3" v-show="modelTab != 0">
                        <label class="control-label col-md-3"
                          >推播顯示文字：</label
                        >
                        <div class="col-md-7">
                          <validate tag="div">
                            <input
                              type="text"
                              name="editName"
                              class="form-control"
                              v-model="row.editName"
                              placeholder="請輸入推播顯示文字"
                              maxlength="30"
                              :required="row.editToSendMessage"
                            />
                            <field-messages
                              name="editName"
                              show="$invalid && $submitted"
                              class="text-danger"
                            >
                              <div slot="required">請輸入推播顯示文字</div>
                            </field-messages>
                          </validate>
                        </div>
                      </div>
                      <div class='row mb-3' v-if="row.editGiveType=='3' || row.editGiveType=='4' || row.editGiveType=='5'">
                        <label class='control-label col-md-3'>是否發推播：</label>
                        <div class='col-md-9'>
                          <toggle-button :disabled="canDelete" v-model="row.editToSendMessage" :sync="true" :height=30 :width=60
                          style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}"/>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label class="control-label col-md-3">贈卷型態：</label>
                        <div class="col-md-7">
                          <validate tag="div">
                            <select
                              id="editGiveType"
                              name="editGiveType"
                              class="form-control"
                              v-model="row.editGiveType"
                              :disabled="true"
                              required
                            >
                              <option disabled value="">請選擇</option>
                              <option value="1">新加入會員</option>
                              <option value="2">生日禮</option>
                              <option value="3">所有正式會員</option>
                              <option value='4'>單一會員</option>
                              <option value='5'>會員資料匯入</option>
                              <option value='6'>店長系統</option>
                            </select>
                            <field-messages
                              name="editGiveType"
                              show="$invalid && $submitted"
                              class="text-danger"
                            >
                              <div slot="required">請選擇贈送條件</div>
                            </field-messages>
                          </validate>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label
                          v-show="row.editGiveType == '1'"
                          class="control-label col-md-3"
                          >受贈會員入會區間：</label
                        >
                        <label
                          v-show="row.editGiveType == '2'"
                          class="control-label col-md-3"
                          >受贈會員生日月份區間：</label
                        >
                        <label
                          v-show="row.editGiveType == '3' || row.editGiveType=='5'"
                          class="control-label col-md-3"
                          >預約贈送日:</label
                        >
                        <div class="col-md-3" v-show="row.editGiveType != '3' && row.editGiveType!='4' && row.editGiveType!='5'">
                          <validate tag="div">
                            <input
                              v-show="row.editGiveType != '2'"
                              type="date"
                              name="editSaleDay_S"
                              class="form-control"
                              v-model="row.editSaleDay_S"
                              @change="ChgTicket()"
                              :min="min_sdate"
                              :max="max_date"
                              :disabled="true"
                              required
                            />
                            <input
                              v-show="row.editGiveType == '2'"
                              type="text"
                              class="form-control"
                              v-model="row.editSaleMon_S"
                              @change="ChgTicket()"
                              :disabled="true"
                            />
                            <field-messages
                              name="editSaleDay_S"
                              show="$invalid && $submitted"
                              class="text-danger"
                            >
                              <div
                                v-if="this.v_SaleDayMsg == ''"
                                slot="required"
                              >
                                &nbsp;請輸入正確的日期格式(起)
                              </div>
                            </field-messages>
                            <div
                              class="text-danger"
                              style="padding: 0.3rem"
                              v-show="this.v_SaleDayMsg != ''"
                            >
                              {{ this.v_SaleDayMsg }}
                            </div>
                          </validate>
                        </div>
                        <label
                          class="control-label"
                          v-show="row.editGiveType != '3' && row.editGiveType!='5' && row.editGiveType != '4'"
                          >至</label
                        >
                        <div class="col-md-3" v-show="row.editGiveType != '4'">
                          <validate tag="div">
                            <input
                              v-show="row.editGiveType != '2'"
                              type="date"
                              name="editSaleDay_E"
                              class="form-control"
                              v-model="row.editSaleDay_E"
                              @change="ChgTicket()"
                              :min="min_sdate"
                              :max="max_date"
                              :disabled="true"
                              required
                            />
                            <input
                              v-show="row.editGiveType == '2'"
                              type="text"
                              class="form-control"
                              v-model="row.editSaleMon_E"
                              @change="ChgTicket()"
                              :disabled="true"
                            />
                            <field-messages
                              name="editSaleDay_E"
                              show="$invalid && $submitted"
                              class="text-danger"
                            >
                              <div slot="required">
                                請輸入正確的日期格式(迄)
                              </div>
                            </field-messages>
                            <div
                              class="text-danger"
                              style="padding: 0.3rem"
                              v-show="this.v_SaleDayEMsg != ''"
                            >
                              {{ this.v_SaleDayEMsg }}
                            </div>
                          </validate>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label class="control-label col-md-3">贈送票券：</label>
                        <div class="col-md-7">
                          <validate tag="div">
                            <select
                              id="editTicket"
                              name="editTicket"
                              class="form-control"
                              v-model="row.editTicket"
                              :disabled="true"
                              required
                            >
                              <option disabled value="">請選擇</option>
                              <option
                                v-for="x in ListTicket"
                                v-bind:value="x.ID"
                                :key="x.ID"
                              >
                                {{ x.Code }} {{ x.Name }}
                              </option>
                            </select>
                            <field-messages
                              name="editTicket"
                              show="$invalid && $submitted"
                              class="text-danger"
                            >
                              <div slot="required">請選擇票券類別</div>
                            </field-messages>
                          </validate>
                        </div>
                      </div>
                      <div class="row mb-3" v-if="row.editGiveType=='4'">
                        <label class="control-label col-md-3">會員手機號碼：</label>
                        <div class="col-md-7">
                          <validate tag="div">
                            <input type='phone' name="Input_Mobile" maxlength="10" v-model='row.editMobile' class='form-control' id='mobile' placeholder='請輸入會員電話' required disabled>
                          </validate>
                        </div>
                      </div>
                      <div class="row mb-3" v-if="row.editGiveType=='5'">
                        <label class="control-label col-md-3">上傳會員名單：</label>
                        <div class="col-md-7">
                          <validate tag="div">
                            <input hidden type="file" name="Input_MemberList" ref="fileInput" id="memberList" accept=".csv" @change="handleFileUpload()">
                            <i class="fa fa-question-circle" style="cursor: pointer;" @click="$refs.importFileDesc.show()"></i>
                            <button
                              type="button"
                              class="btn btn-warning text-white ml-2"
                              @click="() => {this.$refs.fileInput.click()}"
                              :disabled="canDelete">
                              {{
                                (this.canDelete) ? '已啟動無法編輯名單' :
                                (this.row.fileName == '' || this.row.memberAmount==0)  ? '重新上傳會員名單' : this.row.fileName
                              }}
                            </button>
                            <span class="text-danger pl-3" v-if="this.row.memberAmount > 0">
                              已匯入{{this.row.memberAmount}}筆會員資料
                            </span>
                            <button type="button" class="btn btn-primary text-white ml-2" @click="resetFile()" v-if="v_MemberList">清除</button>
                          </validate>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label class="control-label col-md-3">異動人員：</label>
                        <div class="col-md-3">
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="row.editUpdId"
                          />
                        </div>
                        <label class="control-label">異動時間：</label>
                        <div class="col-md-3">
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="row.updatedAt"
                          />
                        </div>
                      </div>
                    </form>
                  </b-container>
                </div>
              </b-card>
              <div class="col-lg-12 text-danger">
                <label
                  v-show="row.editGiveType == '1'"
                  class="control-label col-md-12"
                  >開始日至結束日為贈送對象，該入會區間的日期為升級正式會員當日</label
                >
                <label
                  v-show="row.editGiveType == '2'"
                  class="control-label col-md-12"
                  >符合上述區間之月份生日者於當月5日，都可收到票券</label
                >
                <label
                  v-show="row.editGiveType == '3' || row.editGiveType=='4' || row.editGiveType == '5'"
                  class="control-label col-md-12"
                  >{{ this.giveTypeMsg }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-form>
    <!-- 匯入檔案說明 -->
    <b-modal ref="importFileDesc" hide-footer title="匯入檔說明">
      <pre class="mb-0" style="font-size:16px">
  檔案格式
  1. 僅限csv檔。
  2. 檔名不限。

  內容限制
  1.僅需輸入手機號碼。
  2.限定每行為10碼數字。
  3.不可有空行(含最後一行)。
  4.會員手機號碼筆數上限為一萬筆。
      </pre>
      <img src="/static/pushMemberImportSample.png" class="img-fluid"/>
    </b-modal>
    <b-modal size='lg' ref="invalidWindow" hide-footer title="檔案解析錯誤詳情">
      <div class="row">
        <div class="col-lg-12">
          <div class="p-4 box-shadow" header="Form Elements">
            <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
              <thead>
                  <tr>
                      <th width="15%">項次</th>
                      <th width="15%">列次</th>
                      <th width="35%">內容</th>
                      <th width="35%">錯誤原因</th>
                  </tr>
                  <tr v-for="v in row.showInvalidList" :key="v.seq">
                      <td>{{v.seq}}</td>
                      <td>{{v.rowNumber}}</td>
                      <td>「{{v.content}}」</td>
                      <td>
                        {{
                          (v.reason) == 1 ? '內容為空值':
                          (v.reason) == 2 ? '內容不符合手機格式':
                          (v.reason) == 3 ? '重複的手機號碼':
                          (v.reason) == 4 ? '會員等級非正式會員':
                          (v.reason) == 5 ? '該會員未存在資料庫中': '未知的錯誤請通知管理員'
                        }}
                      </td>
                  </tr>
              </thead>
            </table>
            <div>
                <div class="row" style="padding: 0 1rem">
                    <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getInvalidList"></b-pagination>
                    <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { API_URL } from '@/store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import miniToastr from 'mini-toastr'
import ToggleButton from 'vue-js-toggle-button'
miniToastr.init()
Vue.use(ToggleButton)
export default {
  data () {
    return {
      formstate: {}, // 驗證用
      min_sdate: '', // 可選的最小日期
      max_date: '9999-12-31',
      products: [],
      row: {
        editId: '',
        editToSendMessage: true,
        editCreatedAt: '',
        editGiveType: '',
        editName: '',
        editTicket: '',
        editSaleDay_S: '',
        editSaleDay_E: '',
        editSaleMon_S: '',
        editSaleMon_E: '',
        editMobile: '',
        editMemberList: [],
        invalidList: [],
        showInvalidList: [],
        fileName: '',
        memberAmount: 0,
        updatedAt: '',
        isSend: true,
        amount: 0
      },
      giveTypeMsg: '',
      v_SaleDayMsg: '',
      v_SaleDayEMsg: '',
      v_MemberList: '',
      modelTab: 0, // 1:上架 2:下架
      FunctionPermission: 0, // 功能權限
      apiUrl: API_URL,
      // --------------------
      checkModelType: 1, // 1儲存, 2:下架
      checkModelTitle: '',
      canDelete: false, // 是否能執行下架
      // --------------------
      ListTicket: [],
      model1: {
        currentPage: 1,
        totalrows: 0,
        rows: 10,
        startRowNum: 0,
        endRowNum: 0
      }
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F31') // 功能權限 帶入功能代碼
    if (this.FunctionPermission >= 2) {
    } else {
      if (this.FunctionPermission === 1) {
        this.$router.push({ name: 'coupon_give_list' })
      } else {
        this.$router.push({ name: 'name' })
      }
    }

    this.query()
    this.ChgTicket()
  },
  methods: {
    ChgTicket: function () {
      var date = new Date()
      var year = 0
      var mon = 0
      var day = 0
      var hours = date.getHours().toString().padStart(2, '0')
      var minutes = date.getMinutes().toString().padStart(2, '0')
      var saleStime = '000000'
      var saleEtime = '235959'
      switch (this.row.editGiveType) {
        case '2':
          if (!this.CheckDateTime(this.row.editSaleMon_S)) {
            return
          }
          this.row.editSaleDay_S =
            this.row.editSaleMon_S.replace('/', '-') + '-01'

          if (!this.CheckDateTime(this.row.editSaleMon_E)) {
            return
          }

          var eMon = this.row.editSaleMon_E.replace('/', '-') + '-01'
          date = new Date(eMon)
          date.setMonth(date.getMonth() + 1)
          date.setDate(date.getDate() - 1)
          year = date.getFullYear()
          mon = date.getMonth() + 1
          if (mon < 10) {
            mon = '0' + mon
          }
          day = date.getDate()
          if (day < 10) {
            day = '0' + day
          }

          this.row.editSaleDay_E = year + '-' + mon + '-' + day

          break
        case '4':
          saleStime = hours + minutes + '00'
          saleEtime = hours + minutes + '59'
          break
      }

      if (this.row.editSaleDay_S !== '' && this.row.editSaleDay_E !== '') {
        return axios
          .post(API_URL + '/web/ticketGive/ticketList', {
            sdate:
              this.row.editSaleDay_S.replace('-', '').replace('-', '') + saleStime,
            edate:
              this.row.editSaleDay_E.replace('-', '').replace('-', '') + saleEtime
          })
          .then((response) => {
            if (response.data.result === '0000') {
              this.ListTicket = response.data.data
            } else {
              if (response.data.result === '0006') {
                this.$parent.logOut(false, true)
              } else {
                miniToastr.error(response.data.message, '錯誤訊息')
              }
            }
            this.$parent.Loading = false
          })
          .catch((error) => {
            miniToastr.error(error, '錯誤訊息')
            this.$parent.Loading = false
          })
      }
    },
    query () {
      var params = this.$route.params
      if (params.item === undefined) {
        this.$router.push({ name: 'coupon_give_list' })
        return
      }
      var item = params.item
      this.modelTab = params.modelTab
      this.row.editId = item.id
      this.row.editName = item.name
      this.row.editCreatedAt = item.createdAt
      this.row.editGiveType = String(item.giveType)
      this.row.editSaleDay_S = item.applicableStartAt.replace(/\//g, '-')
      this.row.editSaleDay_E = item.applicableEndAt.replace(/\//g, '-')
      this.row.editToSendMessage = item.toSendMessage
      this.row.editSaleMon_S = this.row.editSaleDay_S
        .substring(0, 7)
        .replace('-', '/')
      this.row.editSaleMon_E = this.row.editSaleDay_E
        .substring(0, 7)
        .replace('-', '/')
      this.row.editTicket = item.giftCertificateID
      this.row.editUpdId = item.updatedName
      this.row.updatedAt = item.updatedAt
      this.row.amount = item.amount
      this.row.editMobile = item.mobile
      this.row.memberAmount = item.memberAmount
      // 設定最小日期
      var date = new Date()
      var year = 0
      var mon = 0
      var day = 0
      if (date.getDate() >= new Date(this.row.editSaleDay_S).getDate()) {
        date = new Date(this.row.editSaleDay_S)
        year = date.getFullYear()
        mon = date.getMonth() + 1
        day = date.getDate()
      } else {
        switch (this.row.editGiveType) {
          case '1':
          case '5':
            date.setDate(date.getDate() + 1)
            year = date.getFullYear()
            mon = date.getMonth() + 1
            day = date.getDate()
            break
          case '2':
            date.setMonth(date.getMonth() + 1)
            year = date.getFullYear()
            mon = date.getMonth()
            day = 1
            break
          case '3':
            date.setDate(date.getDate() + 3)
            year = date.getFullYear()
            mon = date.getMonth() + 1
            day = date.getDate()
            break
        }
      }

      if (mon < 10) {
        mon = '0' + mon
      }

      if (day < 10) {
        day = '0' + day
      }
      this.min_sdate = year + '-' + mon + '-' + day

      // 活動類型為所有會員，則需判斷可執行下架
      if (this.row.editGiveType === '3' || this.row.editGiveType === '5') {
        // 20210331 修改為兩點前且尚未贈送就顯示下架按鈕
        var createAt = new Date(this.row.editCreatedAt)
        var editTime = new Date(this.row.editCreatedAt)
        if (createAt.getHours() > 14 || (createAt.getHours() === 14 & createAt.getMinutes() >= 10)) {
          editTime.setDate(createAt.getDate() + 1)
        }
        editTime.setHours(14, 10, 0, 0)
        var nowDate = new Date()
        if (this.row.amount > 0 || nowDate >= editTime) {
          this.giveTypeMsg = '排程已啟動，無法取消活動'
          this.canDelete = true
        } else {
          this.canDelete = false
          if (nowDate.getDate() === editTime.getDate()) {
            this.giveTypeMsg = '如有下架取消贈券活動或變更推播發送功能需求，請於14:10前完成'
          } else {
            this.giveTypeMsg = '如有下架取消贈券活動或變更推播發送功能需求，需於【隔日】14:10前完成'
          }
        }
      }
      if (this.row.editGiveType === '4') {
        this.giveTypeMsg = '排程已啟動，無法取消活動'
        this.canDelete = true
      }
    },
    onSubmit () {},
    edit () {
      this.update(0)
    },
    update (status) {
      this.$parent.Loading = true
      var edate = this.row.editSaleDay_E
      if (this.checkModelType === 2) {
        // 若下架，則設定前一天
        edate = this.getDate(-1)
      }
      this.checkModelByCancel()
      return axios
        .post(API_URL + '/web/ticketGive/update', {
          id: this.row.editId,
          giveType: Number(this.row.editGiveType),
          name: this.row.editName,
          giftCertificateID: this.row.editTicket,
          toSendMessage: this.row.editToSendMessage,
          sdate: this.row.editSaleDay_S.replace(/-/g, ''),
          edate: edate.replace(/-/g, ''),
          mobiles: this.row.editMemberList
        })
        .then((response) => {
          switch (response.data.result) {
            case '0000':
              var modelTab = this.$route.params.modelTab
              miniToastr.success('更新成功')
              this.$router.push({
                name: 'coupon_give_list',
                params: {
                  queryTab1: this.$route.params.queryTab1,
                  queryTab2: this.$route.params.queryTab2,
                  collapse: this.$route.params.collapse,
                  modelTab: modelTab
                }
              })
              break
            case '0006':
              this.$parent.logOut(false, true)
              break
            case '1503':
              this.resetFile()
              this.row.invalidList = response.data.invalidMobiles.sort((a, b) => a.rowNumber - b.rowNumber)
              this.model1.totalrows = this.row.invalidList.length
              this.row.invalidList = this.row.invalidList.map((item, index) => {
                item.seq = index + 1
                return item
              })
              this.$refs.invalidWindow.show()
              this.getInvalidList(1)
              miniToastr.error(response.data.message, '錯誤訊息')
              break
            default:
              miniToastr.error(response.data.message, '錯誤訊息')
              break
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
        .finally(() => {
          this.$parent.Loading = false
        })
    },
    updateForDelete () {
      this.$parent.Loading = true
      this.checkModelByCancel()
      return axios
        .post(API_URL + '/web/ticket/delete', {
          id: this.row.editId,
          updatedAt: this.row.updatedAt
            .replace(/\//g, '')
            .replace(/:/g, '')
            .replace(/ /g, '')
        })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('草稿刪除成功')
            this.$router.push({
              name: 'coupon_give_list',
              params: {
                queryTab1: this.$route.params.queryTab1,
                queryTab2: this.$route.params.queryTab2,
                collapse: this.$route.params.collapse,
                modelTab: this.$route.params.modelTab
              }
            })
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    getDate: function (addDay) {
      var time = new Date()
      time.setDate(time.getDate() + addDay)
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    checkModelByOpen (type) {
      this.checkModelType = type
      switch (type) {
        case 2:
          this.checkModelTitle = '下架'
          break
        default:
          this.checkModelTitle = '儲存'
      }

      if (this.row.editGiveType === '2') {
        if (!this.CheckDateTime(this.row.editSaleMon_S)) {
          this.v_SaleDayMsg = '起始月份格式錯誤'
          this.$parent.verificationErrMsg()
          return
        }

        if (
          new Date(
            this.row.editSaleMon_S.replace('/', '-') + '-01').getMonth() <
            new Date(this.min_sdate).getMonth() &&
            new Date(this.row.editSaleMon_S.replace('/', '-') + '-01').getFullYear() <=
            new Date(this.min_sdate).getFullYear()
        ) {
          this.v_SaleDayMsg = '起始月份應大於本月'
          this.$parent.verificationErrMsg()
          return
        }

        if (!this.CheckDateTime(this.row.editSaleMon_E)) {
          this.v_SaleDayMsg = '結束月份格式錯誤'
          this.$parent.verificationErrMsg()
          return
        }

        if (
          new Date(
            this.row.editSaleMon_E.replace('/', '-') + '-01').getMonth() <
            new Date(this.min_sdate).getMonth() &&
            new Date(this.row.editSaleMon_E.replace('/', '-') + '-01').getFullYear() <=
            new Date(this.min_sdate).getFullYear()
        ) {
          this.v_SaleDayMsg = '結束月份應大於本月'
          this.$parent.verificationErrMsg()
          return
        }
      }

      // if (this.row.editGiveType === '3') {
      //   if (new Date(this.row.editSaleDay_E).getDate() < new Date().getDate()) {
      //     this.v_SaleDayEMsg = '結束日應大於今日'
      //     this.$parent.verificationErrMsg()
      //     return
      //   }
      //   this.v_SaleDayMsg = '結束日應大於今日'
      // }

      if (
        this.row.editSaleDay_S !== '' &&
        this.row.editSaleDay_E !== '' &&
        this.row.editSaleDay_S > this.row.editSaleDay_E
      ) {
        this.v_SaleDayMsg = '起始日不可大於結束日'
      } else {
        this.v_SaleDayMsg = ''
      }

      if (
        this.formstate.$invalid ||
        this.v_SaleDayMsg !== '' ||
        this.v_SaleDayEMsg !== ''
      ) {
        this.$parent.verificationErrMsg()
      } else {
        this.$refs.checkModel.show()
      }
    },
    checkModelByCancel () {
      this.$refs.checkModel.hide()
    },
    CheckDateTime (mystring) {
      var reg = /^(\d{4})\/(\d{2})$/
      var str = mystring
      if (str === '') return true
      if (!reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31) {
        return false
      }
      return true
    },
    handleFileUpload: async function () {
      let invalid = false
      const file = this.$refs.fileInput.files[0]
      if (file.size > 1024 * 1024 * 1 || file.name.slice(-4) !== '.csv') {
        miniToastr.error('上傳的會員名單過大')
        invalid = true
      }
      const reader = new FileReader()
      reader.readAsText(file)
      const frdDoneEvent = await new Promise(resolve => { reader.onload = resolve })
      // 過濾換行符號、空白、及空的元素
      const uploadMembers = frdDoneEvent.target.result.split('\n').map(item => item.trim())
      const maxMemberAmount = 10000 // 上限
      if (uploadMembers.length > maxMemberAmount) {
        miniToastr.error(`匯入會員名單超過 ${maxMemberAmount} 筆上限`)
        invalid = true
      }

      // 篩選
      const uniqueMap = new Map()
      this.row.invalidList = []
      this.model1.totalrows = 0
      let countRows = 0
      uploadMembers.forEach((mobile, index) => {
        let valid = false
        let reason = 0
        if (!mobile) {
          reason = 1
        } else if (!/^09\d{8}$/.test(mobile)) {
          reason = 2
        } else if (uniqueMap.get(mobile)) {
          reason = 3
        } else {
          valid = true
        }
        if (!valid) {
          countRows++
          this.row.invalidList.push({
            seq: countRows,
            rowNumber: index + 1,
            content: mobile,
            reason: reason
          })
        }
        uniqueMap.set(mobile, true)
      })
      if (countRows > 0) {
        this.model1.totalrows = countRows
        invalid = true
      }
      if (invalid) {
        this.row.fileName = ''
        this.row.editMemberList = []
        this.row.memberAmount = 0
        document.getElementById('memberList').value = null
        miniToastr.error('會員名單解析失敗請檢查內容')
        this.$refs.invalidWindow.show()
        this.getInvalidList(1)
      } else {
        this.v_MemberList = true
        this.row.fileName = file.name
        this.row.editMemberList = uploadMembers
        this.row.memberAmount = this.row.editMemberList.length
        miniToastr.success('會員名單解析成功')
      }
    },
    getInvalidList (currentPage) {
      this.model1.currentPage = currentPage
      const startIndex = (this.model1.currentPage - 1) * this.model1.rows
      const endIndex = this.model1.currentPage * this.model1.rows
      let invalidArray = []
      if (endIndex < this.model1.totalrows) {
        invalidArray = this.row.invalidList.slice(startIndex, endIndex)
      } else {
        invalidArray = this.row.invalidList.slice(startIndex)
      }
      this.row.showInvalidList = invalidArray
      this.model1.startRowNum = (this.model1.totalrows === 0) ? 0 : startIndex + 1
      this.model1.endRowNum = (this.model1.totalrows === 0) ? 0 : (this.model1.totalrows < endIndex) ? this.model1.totalrows : endIndex
    },
    resetFile () {
      this.row.fileName = ''
      this.row.editMemberList = []
      this.row.memberAmount = 0
      document.getElementById('memberList').value = null
      this.v_MemberList = false
      this.row.invalidList = []
      this.model1.totalrows = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/coupon/give/Edit.vue